import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=1aed9105"
import script from "./Accounting.vue?vue&type=script&lang=ts"
export * from "./Accounting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aed9105')) {
      api.createRecord('1aed9105', component.options)
    } else {
      api.reload('1aed9105', component.options)
    }
    module.hot.accept("./Accounting.vue?vue&type=template&id=1aed9105", function () {
      api.rerender('1aed9105', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Accounting.vue"
export default component.exports